export const MAILJET_MODULE_OPTIONS = "MAILJET_MODULE_OPTIONS";
